export function developmentPreviewDestination(
  requestedPath: string,
  previewsEnabled: boolean,
): string {
  return previewsEnabled ? requestedPath : "/";
}
